// extracted by mini-css-extract-plugin
export var borderRadius = "_f4-4";
export var large = "_f4-3";
export var logoContainer = "_f4-0";
export var nameLogo = "_f4-2";
export var small = "_f4-1";